import { render, staticRenderFns } from "./PARFormulaeSummary.vue?vue&type=template&id=4ddaad80&"
import script from "./PARFormulaeSummary.vue?vue&type=script&lang=js&"
export * from "./PARFormulaeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports